import React from "react";
import { STEPS } from "../mock";

export default function HowItWorks() {
  return (
    <section id="how" className="bg-[#fdfaf7]">
      <div className="max-w-7xl mx-auto px-5 py-16">
        <h2 className="font-display text-3xl sm:text-4xl text-[#1f1a1b] text-center">How SimplySitter Works</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
          {STEPS.map((s) => (
            <div key={s.n} className="relative">
              <div className="w-14 h-14 rounded-2xl bg-[#7c2233] text-white font-display text-2xl flex items-center justify-center shadow-[0_12px_30px_-12px_rgba(124,34,51,0.6)]">
                {s.n}
              </div>
              <h3 className="font-display text-xl text-[#1f1a1b] mt-5 leading-snug">{s.title}</h3>
              <p className="text-[15px] text-[#5a5254] mt-2 leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
